import { Link } from "react-router-dom";
import museoCarta from "../../images/Ascoli P. Cart. Palale 10.jpg";
import mulini from "../../images/Ascoli P. Cart. Palale 14.jpg";
import mostraInterattiva from "../../images/IMG_2406.jpg";
import biblioteca from "../../images/biblioteca toria.jpg";
import museo3 from "../../images/museo3.jpg";
import css from "./HomePage.module.css";

export default function HomePage() {
  return (
    <>
      <section className={css["jumbotron-home"]}>
        <div className="p-5">
          <div className="container-fluid py-5 text-center">
            <div className={css["title-container"]}>
              <h1 className="display-3 fw-light lh-1">
                Museo di Storia Naturale
              </h1>
              <h1 className="display-3 fw-semibold lh-1 mb-4">
                Antonio Orsini
              </h1>
            </div>
            <p className="fs-2">Ascoli Piceno | Italy</p>
            <div
              className="d-flex flex-column flex-md-row gap-3 justify-content-center"
              style={{ margin: "40px auto 60px" }}
            >
              <Link
                to="/museo"
                className="btn btn-primary btn-lg bd-btn-lg fw-semibold"
              >
                Scopri
              </Link>
              <Link
                to="/visita"
                className="btn btn-secondary btn-lg bd-btn-lg fw-semibold"
              >
                Visita
              </Link>
            </div>
          </div>
        </div>
        <div className={css["freepik-quote-container"]}>
          <p>
            Image by{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.freepik.com/free-vector/green-watercolor-leaves-background_13295055.htm#query=watercolor%20eucalyptus&position=17&from_view=keyword&track=ais"
            >
              Freepik
            </a>
          </p>
        </div>
      </section>

      <section id="location" className="bg-light">
        <div className="container">
          <div className="row mb-2">
            <h1 className="text-center mt-5 fw-light">La Cartiera Papale</h1>
          </div>
          <div className="row">
            <p className="lead" style={{ textAlign: "justify" }}>
              I Musei della Cartiera Papale hanno sede nella struttura che fin
              dal medioevo inglobava gli opifici costituiti dai mulini e dalla
              cartiera, posti poco fuori delle mura cittadine, sulla riva destra
              del fiume Castellano, dalle cui acque traevano entrambi la forza
              motrice, nella zona della città denominata prima Porta Molinara,
              poi porta Cartara. Il maestoso complesso edilizio fu realizzato
              nel 1512, su iniziativa di papa Giulio II Della Rovere, come
              testimoniano le iscrizioni poste sui due eleganti portali in
              travertino della facciata principale. L'opera fu commissionata
              all'architetto Alberto da Piacenza, che si avvalse anche
              dell'apporto dell'illustre artista Cola dell'Amatrice. L'attuale
              struttura è il risultato del restauro compiuto tra il 1989 e il
              1995; di proprietà della Provincia di Ascoli Piceno, costituisce
              un prestigioso polo monumentale, tecnologico e storico-culturale.
            </p>
          </div>
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 p-md-5 p-3">
              <img
                src={museo3}
                alt="Museo Orsini"
                className="img-fluid shadow bg-body rounded"
              />
            </div>
            <div className="col-12 col-lg-6 p-md-5 p-3">
              <h3>Museo di Storia Naturale "Antonio Orsini"</h3>
              <p className="lead">
                Il Museo di Storia Naturale "Antonio Orsini" accoglie la
                vastissima collezione naturalistica dello scienziato ascolano
                Antonio Orsini negli arredi originali ottocenteschi.
              </p>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 p-md-5 p-sm-3 order-2 order-sm-1">
              <h3>Il Museo della Carta </h3>
              <p className="lead">
                Il Museo della Carta comprende la ricostruzione negli ambienti
                originari dei macchinari impiegati nel passato per la
                fabbricazione della carta.
              </p>
            </div>
            <div className="col-12 col-lg-6 p-md-5 p-sm-3 order-1 order-sm-2">
              <img
                src={museoCarta}
                alt=""
                className="img-fluid shadow bg-body rounded"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 p-md-5 p-3">
              <img
                src={mostraInterattiva}
                alt="Mostra Tutta L'Acqua del mondo"
                className="img-fluid shadow bg-body rounded"
              />
            </div>
            <div className="col-12 col-lg-6 p-md-5 p-3">
              <h3>Mostra "Tutta l'Acqua del mondo"</h3>
              <p className="lead">
                La mostra interattiva multimediale "Tutta l'Acqua del mondo"
                offre l'opportunità di approfondire i temi legati all'acqua ed
                alle trasformazioni del paesaggio che questa determina.
              </p>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 p-md-5 p-sm-3 order-2 order-sm-1">
              <h3>Antichi mulini</h3>
              <p className="lead">
                Gli antichi mulini espongono i resti e le ricostruzioni delle
                macine del grano alimentate dal fiume Castellano.
              </p>
            </div>
            <div className="col-12 col-lg-6 p-md-5 p-sm-3 order-1 order-sm-2">
              <img
                src={mulini}
                alt="Antichi mulini"
                className="img-fluid shadow bg-body rounded"
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-12 col-lg-6 p-md-5 p-3">
              <img
                src={biblioteca}
                alt="Biblioteca Ugo Toria"
                className="img-fluid shadow bg-body rounded"
              />
            </div>
            <div className="col-12 col-lg-6 p-md-5 p-3">
              <h3>Biblioteca "Ugo Toria"</h3>
              <p className="lead">
                La Cartiera accoglie anche la Biblioteca provinciale di Storia
                Contemporanea "Ugo Toria", con oltre 20.000 volumi sulla storia
                e sulle tradizioni del territorio Piceno.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
